import { Component, ElementRef, Input, ViewChild } from "@angular/core";
import { SearchRequest } from "src/app/inventory/supplier/search-request";
import { Page } from "src/app/util/page";
import { Supplier } from "../supplier";
import { SupplierService } from "../supplier.service";

@Component({
  selector: "supplier-picker",
  styleUrls: ["./supplier-picker.component.css"],
  templateUrl: "./supplier-picker.component.html"
})
export class SupplierPickerComponent {
  @Input()
  public onSupplierSelected!: Function;

  @ViewChild('input')
  input!: ElementRef;

  public searchRequest: SearchRequest = { name: "" };
  public results!: Page<Supplier>;
  public supplier!: Supplier;

  constructor(private supplierService: SupplierService) {
    this.search();
  }

  public focusInput() {
    setTimeout(() => this.input.nativeElement.focus());
  }

  public search() {
    this.supplierService.search(this.searchRequest)

      .subscribe(results => this.results = results);
  }

  public select(supplier: Supplier) {

    this.supplier = supplier;

    this.onSupplierSelected(supplier);
  }
}